module.exports = __webpack_public_path__ + "img/curved-rail-vertical-left-top-backplates-remnants.781c341f.png";